var ScrollTop = {
    conf: {
        scrollTimeout: 0
    },
    init: function(n, elem) {
        var self = this;
        var conf = self.conf;
        switch(n) {
            case "":
                var scrollTimeout = null;

                $(window).on("scroll", function()
                {
                    if (self.scrollTimeout == null)
                    {
                        self.scrollTimeout = setTimeout(function()
                        {
                            if ($(window).scrollTop() > 0)
                            {
                                if (!$(elem).is(":visible"))
                                {
                                    $(elem).fadeIn();
                                }
                            }
                            else if ($(elem).is(":visible"))
                            {
                                $(elem).fadeOut();
                            }

                            self.scrollTimeout = null;
                        }, 500);
                    }
                });

                $(elem).click(function()
                {
                    $("html,body").animate({ scrollTop: 0 }, "fast", "swing");
                });

                if ($(window).scrollTop() > 0)
                {
                    if (!$(elem).is(":visible"))
                    {
                        $(elem).fadeIn();
                    }
                }
                else if ($(elem).is(":visible"))
                {
                    $(elem).fadeOut();
                }
                break;
        }
    }
};

module.exports = ScrollTop;